import { render } from "./ManageRole.vue?vue&type=template&id=0b9fea16&scoped=true"
import script from "./ManageRole.vue?vue&type=script&lang=js"
export * from "./ManageRole.vue?vue&type=script&lang=js"

import "./ManageRole.vue?vue&type=style&index=0&id=0b9fea16&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9fea16"]])

export default __exports__